import { PRIVATE_USER } from "Shared/Routing/Application/Constants/PathsConstant";

export const PRIVATE_IMPROVEMENT_PROPOSAL_LIST = PRIVATE_USER + "/list-improvement-proposal";
export const PRIVATE_IMPROVEMENT_PROPOSAL_FORM = PRIVATE_USER + "/form-improvement-proposal";
export const PRIVATE_IMPROVEMENT_PROPOSAL_APPROVAL = PRIVATE_USER + "/improvement-proposal-approval";
export const PRIVATE_IMPROVEMENT_PROPOSAL_TRACKING = PRIVATE_USER + "/improvement-proposal-tracking";
export const PRIVATE_IMPROVEMENT_PROPOSAL_HISTORY = PRIVATE_USER + "/improvement-proposal-history";


